<template>
  <div id="app">
    <div class="designtoolcontainer">
      <DesignCanvas ref="canvas" />
    </div>

    <GuideControls></GuideControls>
    <ProductSwitcher v-on:designLoaded="$refs.canvas.designLoaded()" ref="switcher" />

    <b-container id="design-toolbar" class="mb-4">
      <b-row align-h="center" class="mb-1">
        <b-col class="center">
          <b-form-input
              class="name mx-auto"
              v-model="design.name"
              placeholder="Untitled design"></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col>
          <b-button-toolbar key-nav aria-label="Design Toolbar">
            <b-button-group class="mx-1">
              <DesignNew @clear="designCleared" />
              <DesignSave />
              <DesignSaveAs />
              <DesignLoad
                  v-on:designLoaded="$refs.canvas.designLoaded()"
                  :loadImmediate="designcode" />
              <Help />
            </b-button-group>
          </b-button-toolbar>
        </b-col>
      </b-row>
      <b-row align-h="center" class="mb-1">
        <b-col class="center">
          <div class="designcode">design code:
            <span>{{ design.designcode || 'unsaved' }}</span>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <div class="option-label">Cap colors</div>
    <OptionSelector></OptionSelector>

    <AddToCart :qtysuggested='product.qtysuggested'></AddToCart>

    <div class="debuginfo">
      <pre>design: {{ design }}</pre>
      <pre>product: {{ product }}</pre>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import devSetup from '@/devsetup';

import DesignCanvas from '@/components/DesignCanvas.vue';
import DesignNew from '@/components/DesignNew.vue';
import DesignLoad from '@/components/DesignLoad.vue';
import DesignSave from '@/components/DesignSave.vue';
import DesignSaveAs from '@/components/DesignSaveAs.vue';
import Help from '@/components/Help.vue';
import OptionSelector from '@/components/OptionSelector.vue';
import GuideControls from '@/components/GuideControls.vue';
import AddToCart from '@/components/AddToCart.vue';
import ProductSwitcher from '@/components/ProductSwitcher.vue';

// Setup is an object set up in the containing page context
// to give us initial load information
let setup = {};
if (window.Setup) {
  setup = window.Setup;
  console.log('loading prod setup:', setup);
} else {
  console.log('loading dev setup');
  setup = devSetup;
}

export default {
  name: 'App',
  components: {
    DesignCanvas,
    DesignNew,
    DesignLoad,
    DesignSave,
    DesignSaveAs,
    Help,
    OptionSelector,
    GuideControls,
    AddToCart,
    ProductSwitcher,
  },
  data() {
    return {
      designcode: setup.designcode || '',
    };
  },
  created() {
    this.$store.commit('setProducts', setup.products);
    this.$store.commit('setLeadProduct', setup.product);
    this.$store.commit('changeCurrentProduct', setup.product);
    this.$store.commit('setConfig', setup.config);
  },
  computed: {
    designName() {
      return this.design.name;
    },
    ...mapState(['product', 'designs', 'leadProduct']),
    ...mapGetters(['design']),
  },
  methods: {
    designCleared() {
      this.$refs.switcher.switchProduct(this.leadProduct);
    },
  },
  watch: {
    designName(newName) {
      Object.keys(this.designs).forEach((k) => {
        const d = this.designs[k];
        if (d.name !== newName) {
          d.name = newName;
        }
      });
    },
  },
};
</script>

<style>
#app {
  margin-top: 1rem;
  text-align: center;
  width:100%;
}

.btn-toolbar {
  justify-content: center;
}

.name {
  width: 90%;
  max-width: 20rem;
}

.designtoolcontainer {
  max-width:400px;
  width:100%;
  margin-left:auto;
  margin-right:auto;
}

.option-label {
  font-size: small;
  color: grey;
  white-space: nowrap;
  width: 100%;
  max-width: 98vw;
  overflow: hidden;
}

.designcode {
  font-size: x-small;
  color: silver;
  white-space: nowrap;
  width: 100%;
  max-width: 98vw;
  overflow: hidden;
}
.designcode span {
  user-select: all;
}

.debuginfo {
  text-align: left;
  padding-left: 1rem;
  display: none;
}

btn.disabled, .btn:disabled {
  opacity: 0.40;
  cursor: not-allowed;
}
</style>
